<template>
  <div>
    <v-card class="mb-6">
      <v-card-title>Regions of Ethiopia</v-card-title>
      <v-card-text>
        <v-form class="mb-4" @submit.prevent="saveRegion">
          <v-row>
            <v-col cols="12" md="4"><v-text-field v-model="region.name" label="Region name" outlined dense></v-text-field></v-col>
            <v-col cols="6" md="2"><v-text-field v-model="region.lat" label="Latitude" outlined dense></v-text-field></v-col>
            <v-col cols="6" md="2"><v-text-field v-model="region.lng" label="Longitude" outlined dense></v-text-field></v-col>
            <v-col cols="12" md="2"><v-btn color="primary" type="submit" depressed>{{ region.id ? 'Update' : 'Add region' }}</v-btn></v-col>
          </v-row>
        </v-form>
        <v-simple-table>
          <thead><tr><th>Region</th><th></th></tr></thead>
          <tbody>
            <tr v-for="r in regions" :key="r.id">
              <td>{{ r.name }}</td>
              <td class="text-right">
                <v-btn text small @click="editRegion(r)">Edit</v-btn>
                <v-btn text small color="error" @click="removeRegion(r)">Remove</v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>

    <v-card>
      <v-card-title>Cities and towns</v-card-title>
      <v-card-text>
        <v-form class="mb-4" @submit.prevent="saveCity">
          <v-row>
            <v-col cols="12" md="3">
              <v-select v-model="city.region_id" :items="regions" item-text="name" item-value="id" label="Region" outlined dense></v-select>
            </v-col>
            <v-col cols="12" md="3"><v-text-field v-model="city.name" label="City / town" outlined dense></v-text-field></v-col>
            <v-col cols="6" md="2"><v-text-field v-model="city.lat" label="Latitude" outlined dense></v-text-field></v-col>
            <v-col cols="6" md="2"><v-text-field v-model="city.lng" label="Longitude" outlined dense></v-text-field></v-col>
            <v-col cols="12" md="2"><v-btn color="primary" type="submit" depressed>{{ city.id ? 'Update' : 'Add city' }}</v-btn></v-col>
          </v-row>
        </v-form>
        <v-simple-table>
          <thead><tr><th>City</th><th>Region</th><th></th></tr></thead>
          <tbody>
            <tr v-for="c in cities" :key="c.id">
              <td>{{ c.name }}</td>
              <td>{{ regionName(c.region_id) }}</td>
              <td class="text-right">
                <v-btn text small @click="editCity(c)">Edit</v-btn>
                <v-btn text small color="error" @click="removeCity(c)">Remove</v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      regions: [],
      cities: [],
      region: { name: '', lat: '', lng: '' },
      city: { name: '', region_id: null, lat: '', lng: '' },
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    regionName(id) {
      const r = this.regions.find((x) => x.id === id)
      return r ? r.name : ''
    },
    async load() {
      const regions = await axios.get('/locations/regions')
      const cities = await axios.get('/locations/cities')
      this.regions = regions.data.regions || []
      this.cities = cities.data.cities || []
    },
    editRegion(r) { this.region = { ...r } },
    editCity(c) { this.city = { ...c } },
    async saveRegion() {
      await axios.post('/locations/regions', this.region)
      this.region = { name: '', lat: '', lng: '' }
      this.load()
    },
    async saveCity() {
      await axios.post('/locations/cities', this.city)
      this.city = { name: '', region_id: this.city.region_id, lat: '', lng: '' }
      this.load()
    },
    async removeRegion(r) {
      await axios.delete('/locations/regions/' + r.id)
      this.load()
    },
    async removeCity(c) {
      await axios.delete('/locations/cities/' + c.id)
      this.load()
    },
  },
}
</script>
